import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationModalComponent } from './confirmation-modal.component';
import { ConfirmationModalService } from './confirmation-modal.service';

@NgModule({
  declarations: [
    ConfirmationModalComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [
    ConfirmationModalService
  ],
  exports: [
    ConfirmationModalComponent
  ]
})
export class ConfirmationModalModule { }
